import React from 'react';
import imageone from './../images/images-master/images-normal/computadora-de-escritorio.png'
import imagetwo from './../images/images-master/images-normal/curso-por-internet.png'
import TitleAlt from './TitleAlt'

const Sentence = () => (
    <section className="sentence">
       <img className="one" src={imageone} alt={TitleAlt} />
           <p>Que el colegio no sea tu único respaldo en tu educacion, no sabes si te estan preparando para el pasado.</p>
       <img className="two" src={imagetwo} alt={TitleAlt} />
    </section>
)

export default Sentence;
